export class PinterestComponent
{
    private $root:JQuery;

    constructor(element:HTMLElement) {
        this.$root = $(element);
    }

    protected init() {
        this.$root.on({ click: this.handlePin });
    }

    handlePin = (ev:any) => {
        ev.stopPropagation();
        let $slide = this.$root.closest('.js-pinterest__target');
        if ($slide.data('url') && $slide.data('media')) {
            // @ts-ignore
            (<any>window).PinUtils.pinOne({
                'url': $slide.data('url'),
                'media': $slide.data('media'),
                'description': $slide.data('description')
            });
        } else {
            // @ts-ignore
            (<any>window).PinUtils.pinAny();
        }
    }
}